
import { Image } from "@chakra-ui/react";

import bannerDesktop from "@root/assets/images/banner-desktop.png";
import bannerMobile from "@root/assets/images/banner-mobile-2.png";


export const DashboardHeader = () => {

  return (
    <>
      <Image
        src={bannerMobile}
        alt="Banner"
        width="100%"
        display={{ base: "block", md: "none" }}
      />
      <Image
        src={bannerDesktop}
        alt="Banner"
        width="100%"
        borderRadius="20px"
        display={{ base: "none", md: "block" }}
      />
    </>
  );
};
